import React from 'react';
import { DarwinDropdown } from '../../Dropdown';
import { DarwinFlex } from '../../Flex';
import styles from './styles.module.css';
import Icon from 'components/darwin-ui/Icon';
import { ActionsDropdownProps } from '../types';

export function ActionsDropdown<T>({
  item,
  getMenuItems,
  disableStopPropagation = false,
}: ActionsDropdownProps<T>) {
  const handleClick = (e: React.MouseEvent) => {
    if (!disableStopPropagation) {
      e.stopPropagation();
    }
  };

  return (
    <DarwinFlex onClick={handleClick} align="center" justify="center">
      <DarwinDropdown
        menu={{ items: getMenuItems(item as T) }}
        trigger={['click']}
        placement="bottom"
        overlayClassName={styles.dropdownOverlay}
      >
        <div className={styles.iconActionContainer}>
          <Icon name="more" size="sm" className={styles.iconAction} />
        </div>
      </DarwinDropdown>
    </DarwinFlex>
  );
}
